import { z } from "zod";
import {
  defaultCreateDiscountCodeValues,
  discountCodeBaseSchema,
  discountCodeLimitSchema,
  withDiscountCodeLimitsRule,
  withDiscountCodeNameRule,
} from "./create-discount-code.schema";
import { BackofficePrestationType } from "@prisma/client";

const discountCodeQuantitySchema = discountCodeLimitSchema("La quantité doit être supérieure à 0");

export const acExpoDiscountCodeSchema = withDiscountCodeLimitsRule(
  withDiscountCodeNameRule(
  z.object({
    prestationTypes: z
      .array(
        z.object({
          prestation: z.nativeEnum(BackofficePrestationType),
          quantity: discountCodeQuantitySchema,
        })
      )
      .default([]),
    equipmentTypes: z
      .array(
        z.object({
          equipmentId: z.string(),
          quantity: discountCodeQuantitySchema,
        })
      )
      .default([]),
    includeDeliveryFees: z.boolean().default(false),
    generalAccount: z.string().optional(),
    eventId: z.string().optional().nullable(),
    eventName: z.string().optional().nullable(),
    organiserId: z.string().optional().nullable(),
    organiserName: z.string().optional().nullable(),
  }).merge(discountCodeBaseSchema),
  ),
)
  .refine((data) => data.prestationTypes.length + data.equipmentTypes.length > 0, {
    message: "Sélectionne au moins une prestation ou un matériel",
    path: ["prestationTypes"],
  })
  .refine(
    (data) => !(data.eventName && data.eventName.length > 0 && !data.eventId),
    {
      message: "Veuillez choisir un événement ou laisser le champ vide",
      path: ["eventId"],
    }
  )
  .refine(
    (data) =>
      !(
        data.organiserName &&
        data.organiserName.length > 0 &&
        !data.organiserId
      ),
    {
      message: "Veuillez choisir un organisateur ou laisser le champ vide",
      path: ["organiserId"],
    }
  );

export const defaultAcExpoDiscountCodeSchemaValues = {
  ...defaultCreateDiscountCodeValues,
  prestationTypes: [],
  equipmentTypes: [],
  includeDeliveryFees: false,
  generalAccount: "",
};

export type AcExpoDiscountCodeForm = z.infer<typeof acExpoDiscountCodeSchema>;
